/**
 * @file productCenter
 * @author WenCe
 */

import {GET_CMSAPI_PRODUCT_LIST} from '../actions/ActionTypes';

export function cmapiProductList(state = {}, actions) {
    switch (actions.type) {
        case GET_CMSAPI_PRODUCT_LIST:
            return {...actions.data};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/productCenter.js